import React from 'react'
import { Button, Props } from './Button'

/**
 * @deprecated - Use UnstyledButton from '@chilipiper/design-system/src/new' instead and provide
 *   your own hover effect
 */
export const UnstyledButton = (props: Props) => {
  return (
    <Button
      px={0}
      alignItems='initial'
      justifyContent='initial'
      bg='transparent'
      boxShadow='none'
      renderRawChildren
      borderRadius='none'
      h='auto'
      display='inline-block'
      textAlign='left'
      htmlType='button'
      {...props}
    />
  )
}
